 export function parsePath(path)
 {  
  if ( path == null ) 
    throw "Path may not be null";

  path = ''+path; // guarantees path is a string...

  let ret = [];
  const parts = path.split('/');

  for ( let i = 0; i < parts.length; i++ )
  {
    let part = parts[i];

    part = part.trim();

    if ( part.length == 0 ) continue;

    ret.push(part);
  }

  return ret;
}

export function pathFromParts(parts)
{
  let ret = '/';

  for ( const part of parts )
  {
    if ( ret.charAt(ret.length-1) != '/' )
      ret += '/';
    
    ret += part.trim();
  }

  return ret;
}

export function populatePathVariables(path, params)
{
  let ret = [];
  const path_parts = parsePath(path);

  for ( const part of path_parts )
  {
    if ( part.length > 0 && part.charAt(0) == ':' )
    {
      let var_name = part.substring(1);

      let value = params['path_param_'+var_name];
      if ( value == null ) value = params[var_name];

      if ( value == null ) 
        continue;

      ret.push(''+value);
      continue;
    }

    ret.push(part);
  }

  return pathFromParts(ret);
}

export function parseRestEndpoint(str)
{
  let idx = str.indexOf(':');

  if ( idx == -1 )
    throw 'Not an rest endpoint: '+str;

  let method = str.substring(0,idx).trim().toUpperCase();
  let path = str.substring(idx+1).trim();

  return {
    'method' : method,
    'path' : path,
  };
}

export function removePathParams(params)
{
  if ( params == null || Array.isArray(params) || typeof params != 'object' )
    throw 'Expected params to be an object';

  let ret = {};

  for ( const key of Object.keys(params) )
  {
    if ( key.toLowerCase().startsWith('path_param_') )
      continue;
    
    ret[key] = params[key];
  }

  return ret;
}

export function createRestCallData(endpoint, params)
{
  let parsed_endpoint = parseRestEndpoint(endpoint);

  let method = parsed_endpoint.method;

  let data = null;
  if ( method != 'GET' )
    data =  removePathParams(params);

  let url = populatePathVariables(parsed_endpoint.path, params);

  let axios_fail_silent = false;

  if ( params != null && params.axios_fail_silent == true )
    axios_fail_silent = true;

  let ret = {
    'method' : method,
    'url' : url,
    'data' : data,
    'axios_fail_silent' : axios_fail_silent,
  };

  if ( params.rest_timeout != null )
  {
    ret.timeout = params.rest_timeout;
  }

  return ret;
}

export function getScrollbarWidth()
{
  // Create a temporary div element to measure scrollbar width
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  document.body.appendChild(outer);

  // Create an inner div and place it in the outer div
  const inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculate the difference between the outer and inner div widths
  const scrollbar_width = (outer.offsetWidth - inner.offsetWidth);

  // Remove the temporary elements
  outer.parentNode.removeChild(outer);

  return scrollbar_width;
}

export default {
    parsePath,
    populatePathVariables,
    pathFromParts,
    parseRestEndpoint,
    removePathParams,
    createRestCallData,
    getScrollbarWidth
};